import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {UserService} from '../../services/user.service';
import {TranslateService} from "@ngx-translate/core";
import {appConfig} from '../../app.config';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';

import {AppLogComponent} from "../app-log/app-log.component";
import {AppTasksComponent} from "../app-tasks/app-tasks.component";
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {UserProfileComponent} from "../user-profile/user-profile.component";
import {UserSettingsComponent} from "../user-settings";
import {UserPictureComponent} from "../user-picture";
// import {AppUserComponent} from "../app-user";
import {Observable} from 'rxjs/Rx';

import {DOCUMENT} from '@angular/platform-browser';
import {OrganizationService} from "../../views/setting/organization/organization.service";
import {SharedService} from "../../services";

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html'
})
export class AppHeaderComponent {
    languages: any[];
    @Input() refShow;
    public screens:any;
    activelang: any;
    LoginUser: any;
    public imgUrl = appConfig.publicUrl;
    @Input() isShow = true;
    @Output() updateValue = new EventEmitter();
    public fullurl = '';
    public orgPic: string;
    public hasNewTask: number = 0;
    public logo = '';
    public systems: any[] = [
        {'name': 'setting', 'icon': 'settings.png'},
        {'name': 'pos', 'icon': 'sale.png'},
        {'name': 'pro', 'icon': 'pur.png'},
        {'name': 'hr', 'icon': 'per.png'},
        {'name': 'fin', 'icon': 'price.png'},
        {'name': 'stock', 'icon': 'sys.png'},
        {'name': 'management','icon':'management.png'},

    ];

    public usersystems: any[] = [];


    constructor(private router: Router,
                private route: ActivatedRoute,
                private modalService: NgbModal,
                private sharedService: SharedService,
                private userService: UserService,
                private organizationService: OrganizationService,
                private authenticationService: AuthenticationService,
                public translate: TranslateService) {
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.lang) {
            this.LoginUser = currentUser;
            this.fullurl = this.imgUrl + 'upload/' + currentUser.picture;
          const organization = JSON.parse(localStorage.getItem('organization'));
          if(organization) {
            this.orgPic = organization.system_logo;
            this.logo = this.imgUrl + 'upload/' + organization.system_logo;
          } else {
            this.organizationService.getById(currentUser.organization_id).subscribe(
              org => {
                localStorage.setItem('organization',JSON.stringify(org));
                this.orgPic = org.system_logo;
                this.logo = this.imgUrl + 'upload/' + org.system_logo;
              }
            );
          }



            if (currentUser.lang === 'en') {

                this.activelang = {'icon': 'flag-icon-us', 'lang': currentUser.lang};
                document.dir = 'ltr';

            } else {
                this.activelang = {'icon': 'flag-icon-sa', 'lang': currentUser.lang};
                document.dir = 'rtl';

            }
        } else {
            this.activelang = {'icon': 'flag-icon-sa', 'lang': 'ar', 'title': 'عربي'};
            this.changeLanguage(this.activelang);

        }

        this.languages = [
            {'icon': 'flag-icon-sa', 'lang': 'ar', 'title': 'عربي'},
            {'icon': 'flag-icon-us', 'lang': 'en', 'title': 'English'}
        ];

        this.changePicUrl();
      const screens = JSON.parse(localStorage.getItem('screens'));
      if(screens) {
        this.screens = screens;
      } else {
        this.sharedService.getAllFavor().subscribe(
          link=> {
            this.screens = link;
          }
        );
      }

        Observable.interval(90000).subscribe(x => { // will execute every 30 seconds
            this.checkUserNewTask();
        });

    }

    ngOnInit() {
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.usersystems = currentUser.systems;
        this.changePicUrl();
    }
    routelink(link:string, code:any) {
        this.router.navigate(['./' + link]);
        let screen ={link, code};
        localStorage.setItem('current_screen', JSON.stringify(screen));
    }
    opensystem(sysname: string) {
        localStorage.setItem('OpenSystem', sysname);
        localStorage.setItem('showMenu',JSON.stringify(true));
        this.router.navigate(['./mainsystem']);
    }

    logout() {
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.authenticationService.logout(currentUser.api_token).subscribe(
        data => {
            localStorage.removeItem('currentUser');
            localStorage.clear();
            window.location.href = '/#/pages/login';
        }
      );
        this.authenticationService.logout();
    }

    toggler() {
      this.isShow = (this.isShow) ? false:true;
      localStorage.setItem('showMenu',JSON.stringify(this.isShow));
      this.updateValue.emit(this.isShow);
    }

    updatePassword() {

        const modalRef = this.modalService.open(UserProfileComponent);
        modalRef.componentInstance.refShow = this.refShow;
        modalRef.componentInstance.rowId = '';
    }

    changePicUrl() {
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser) {
            this.fullurl = this.imgUrl + 'upload/' + currentUser.picture;
        }
    }

    updatePicture() {
        const options: NgbModalOptions = {
            beforeDismiss: () => {
                this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(UserPictureComponent, options);
        modalRef.componentInstance.refShow = this.refShow;
        modalRef.componentInstance.rowId = '';
    }

    accountSettings() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(UserSettingsComponent, options);
        modalRef.componentInstance.refShow = this.refShow;
        modalRef.componentInstance.rowId = '';

    }

    changeLanguage(lang: any) {
        this.translate.use(lang.lang);
        this.activelang = lang;
        if (lang.lang === 'en') {
            document.dir = 'ltr';
        } else {
            document.dir = 'rtl';
        }
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.lang) {
            currentUser.lang = lang.lang;
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
        }
    }

    showTasks(item: any) {
        this.router.navigate(['/taskpost']);
    }

    checkUserNewTask(){
        this.userService.hasTask().subscribe(
            user => {
                this.hasNewTask = user.hasTasks;
          },
          err => {
                console.log(err);
          }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/app-header/app-header.component.ts